import React, { Fragment } from "react";
import MiniCarHero from "../common/MiniCarHero";
import Container from "../../../../../../common-deprecated/styles/v2/lexus/globals/Container";
import * as Flex from "../../../../../../common-deprecated/styles/v2/lexus/globals/Flex";
import * as Type from "../../../../../../common-deprecated/styles/v2/lexus/globals/Type";
import * as ServiceStyles from "./styles/SharedService";
import useServices from "../../../hooks/services/useServices";
import DisclaimerContainer from "../common/disclaimer/DisclaimerContainer";
import Divider from "../../../../../../common-deprecated/styles/lexus/Divider";
import { BnbLabel, useBnbOptionalLabel } from "../../../utils/labels";
import BasketFinanceTogglePanel from "../common/basket-financetoggle-panel/BasketFinanceTogglePanel";
import Basket from "../common/basket/Basket";
import SidebarWrapper from "../../../../../../common-deprecated/components/SidebarWrapper";
import Separator from "../../../../../../common-deprecated/styles/v2/lexus/globals/Separator";
import BottomNavigation from "../common/nav/BottomNavigation";
import { GreyBackground } from "../../../../../../common-deprecated/styles/lexus/Background";
import { ServiceTypeEnum } from "../../../../../../common-deprecated/types/SettingsType";
import TradeInService from "./TradeInService";
import FinanceService from "./FinanceService";
import InsuranceService from "./InsuranceService";
import BannerService from "./BannerService";
import { NAV_PRIMARY_HEIGHT } from "../../../../../../common-deprecated/styles/v2/lexus/components/Navigation";
import { BASKET_HEADER_TOP_MARGIN } from "../common/basket/styles/Basket";
import { useBnbSelector } from "../../../redux/store";
import Finance from "../step-customize/main-content/Finance";
import Insurance from "../step-customize/main-content/Insurance";

const ServicesContainer = (): JSX.Element => {
    const { services } = useServices();

    const description = useBnbOptionalLabel("servicesDescription");
    const { showFinanceInsuranceInPage, enableFinanceCompare } = useBnbSelector((state) => state.bnbSettings);

    const components = services
        .map((service) => {
            if (service.type === ServiceTypeEnum.Tradein) return <TradeInService />;
            if (service.type === ServiceTypeEnum.Finance)
                return showFinanceInsuranceInPage || enableFinanceCompare ? (
                    <Finance showIntroduction={!enableFinanceCompare} />
                ) : (
                    <FinanceService />
                );
            if (service.type === ServiceTypeEnum.Insurance)
                return showFinanceInsuranceInPage || enableFinanceCompare ? (
                    <Insurance showIntroduction={!enableFinanceCompare} />
                ) : (
                    <InsuranceService />
                );
            if (service.type === ServiceTypeEnum.Banner) return <BannerService />;
            return null;
        })
        .filter((service) => !!service);

    return (
        <>
            <Container mt={4}>
                <Flex.Row>
                    <Flex.Col width={{ xs: 1, lg: 2 / 3 }}>
                        <MiniCarHero showChangeLink />
                        <Separator />

                        <ServiceStyles.IntroductionWrapper>
                            <Type.H4>
                                <BnbLabel label="servicesIntroduction" />
                            </Type.H4>
                            {description && (
                                <ServiceStyles.IntroductionDescription
                                    dangerouslySetInnerHTML={{ __html: description }}
                                />
                            )}
                        </ServiceStyles.IntroductionWrapper>

                        {components.map(
                            (component, index) =>
                                !!component && (
                                    // eslint-disable-next-line react/no-array-index-key
                                    <Fragment key={index}>
                                        {component}
                                        {index < services.length - 1 && <Divider colorName="grey2" />}
                                    </Fragment>
                                ),
                        )}

                        {components.length < 1 && (
                            <Type.H2 mb={4}>
                                <BnbLabel label="noServices" />
                            </Type.H2>
                        )}

                        <BottomNavigation />
                    </Flex.Col>
                    <Flex.Col display={{ xs: "none", lg: "block" }} width={1 / 3} position="relative">
                        <SidebarWrapper top={NAV_PRIMARY_HEIGHT} paddingTop={BASKET_HEADER_TOP_MARGIN}>
                            <BasketFinanceTogglePanel />
                            <Basket attached />
                        </SidebarWrapper>
                    </Flex.Col>
                </Flex.Row>
            </Container>
            <GreyBackground mt={4} mb={4}>
                <Container>
                    <DisclaimerContainer showGenericFinanceDisclaimer hasDarkBackground />
                </Container>
            </GreyBackground>
        </>
    );
};

export default ServicesContainer;
